import React from 'react'
import './mf-table.css'
import { Table } from 'react-bootstrap'

const MFTable: React.FunctionComponent<{ tableData: Array<any>, headerData: Array<any> }> = ({ tableData, headerData }) => {
  return (
    <Table className='mf-table' responsive>
      <thead className='mf-table-head'>
        <tr className='mf-table-head-row'>
          {
            headerData.length !== 0 &&
            headerData.map((header, index) =>
              <th key={index} className='font-13 weight-500 text-capitalize'>
                {header.column_name || ''}
              </th>
            )
          }
        </tr>
      </thead>
      <tbody className='mf-table-body'>
        {
          tableData.map((row, index) => (
            <tr key={index} className='mf-table-body-row'>
              {headerData.map((key) =>
                <td key={row.id} className='font-13 weight-400'>
                  {`${row[key.key]}`}
                </td>
              )}
            </tr>
          ))
        }
      </tbody>
    </Table>
  )
}

export default MFTable